module.exports = __webpack_public_path__ + "static/media/credit-score-illustration.90861886.png";